"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMortgageGlossary = initMortgageGlossary;
const firebase_1 = require("./firebase");
const firestore_1 = require("firebase/firestore");
const arrow_left_svg_1 = __importDefault(require("./assets/icons/arrow-left.svg"));
const arrow_right_svg_1 = __importDefault(require("./assets/icons/arrow-right.svg"));
const FIRESTORE_COLLECTION = "mortgage_glossary";
function initMortgageGlossary(container) {
    container.innerHTML = `
      <div class="mortgage-glossary">
        <div class="header-wrapper">
            <div class="section-heading">Mortgage Glossary</div>
            <div class="glossary-controls">
                <div class="arrow-left"><img src="${arrow_left_svg_1.default}" alt="Expand/Collapse" /></div>
                <div class="alphabets"></div>
                <div class="arrow-right"><img src="${arrow_right_svg_1.default}" alt="Expand/Collapse" /></div>
            </div>
        </div>
        <div class="glossary-list"></div>
      </div>
    `;
    const mortgageGlossary = container.querySelector(".mortgage-glossary");
    const headerWrapper = container.querySelector(".header-wrapper");
    const glossaryList = container.querySelector(".glossary-list");
    if (!mortgageGlossary || !headerWrapper || !glossaryList)
        return;
    loadMortgageGlossary(container);
    // const handleScroll = async () => {
    // const glossaryRect = mortgageGlossary.getBoundingClientRect();
    // const isInViewport = glossaryRect.top <= 0 && glossaryRect.bottom > 0;
    // if (isInViewport) {
    //     headerWrapper.classList.add("sticky");
    // } else {
    //     headerWrapper.classList.remove("sticky");
    // }
    // };
    // const throttle = (func: Function, limit: number) => {
    //     let lastCall = 0;
    //     return (...args: any[]) => {
    //         const now = Date.now();
    //         if (now - lastCall >= limit) {
    //             lastCall = now;
    //             func(...args);
    //         }
    //     };
    // };
    // window.addEventListener("scroll", throttle(handleScroll, 200));
}
function loadMortgageGlossary(container) {
    return __awaiter(this, void 0, void 0, function* () {
        const mortgageGlossary = container.querySelector(".mortgage-glossary");
        const glossaryList = container.querySelector(".glossary-list");
        const alphabets = container.querySelector(".alphabets");
        if (!glossaryList)
            return;
        try {
            const db = yield (0, firebase_1.getFirestoreInstance)();
            let glossaryQuery = (0, firestore_1.query)((0, firestore_1.collection)(db, FIRESTORE_COLLECTION), (0, firestore_1.orderBy)("term", "asc"));
            const querySnapshot = yield (0, firestore_1.getDocs)(glossaryQuery);
            if (querySnapshot.empty) {
                console.log("No mortgage glossary available");
                return;
            }
            let groupedGlossary = {};
            querySnapshot.forEach((doc) => {
                var _a, _b;
                const glossaryData = doc.data();
                const firstLetter = glossaryData.term.charAt(0).toUpperCase();
                let isFirstLetterItem = false;
                if (!groupedGlossary[firstLetter]) {
                    groupedGlossary[firstLetter] = [];
                    isFirstLetterItem = true;
                }
                groupedGlossary[firstLetter].push(glossaryData);
                const glossaryElement = document.createElement("div");
                glossaryElement.classList.add("glossary-item");
                if (isFirstLetterItem)
                    glossaryElement.setAttribute("data-glosssary-control-letter", firstLetter);
                glossaryElement.innerHTML = `
                <div class="term">${(_a = glossaryData.term) === null || _a === void 0 ? void 0 : _a.trim()}</div>
                <div class="definition">${(_b = glossaryData.definition) === null || _b === void 0 ? void 0 : _b.trim()}</div>
            `;
                glossaryList.appendChild(glossaryElement);
            });
            console.log(groupedGlossary, " - groupedGlossary");
            const alphabetKeys = Object.keys(groupedGlossary);
            let alphabetsHTMLString = "";
            alphabetKeys.forEach((alphabet) => {
                alphabetsHTMLString += `<div class="alphabet">${alphabet}</div>`;
            });
            alphabets.innerHTML = alphabetsHTMLString;
            mortgageGlossary.addEventListener("click", (event) => {
                const target = event.target;
                if (target.closest(".arrow-right")) {
                    alphabets.scrollLeft += 150;
                }
                else if (target.closest(".arrow-left ")) {
                    alphabets.scrollLeft -= 150;
                }
                else if (target.closest(".alphabet")) {
                    const firstLetterElement = document.querySelector(`[data-glosssary-control-letter="${target.textContent}"]`);
                    if (firstLetterElement) {
                        const elementOffsetTop = firstLetterElement.getBoundingClientRect().top + window.scrollY;
                        const offset = window.innerWidth < 992 ? 200 : 275;
                        window.scrollTo({
                            top: elementOffsetTop - offset,
                            behavior: "smooth",
                        });
                    }
                }
            });
        }
        catch (error) {
            console.error("Error loading mortgage glossary:", error);
        }
    });
}
